const CurrentYear = () => {
  const currentYear = new Date().getFullYear().toString()
  const years = Array.from( document.getElementsByClassName('year') as HTMLCollectionOf<HTMLElement> )
  years.forEach((year: HTMLElement) => {
    year.innerText = currentYear
  })
}

export default CurrentYear
